module.exports = __webpack_public_path__ + "img/access.8235fa5.svg";